<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right"></i>
      </button>
      <div class="title-block">
        <h1 class="title">{{ definition.title }}</h1>
        <span class="muted">{{ subtitle | faNum }}</span>
      </div>
    </div>
  </header>
  <section class="card">
    <div class="table-toolbar">
      <label class="search-wrap"><input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" [placeholder]="searchPlaceholder" [disabled]="loading"><i class="fa fa-search"></i></label>
      <div class="toolbar-actions">
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" [useExistingCss]="true" ngxPrint [printTitle]="definition.title" [printSectionId]="printSectionId"><i class="fa fa-print"></i> چاپ</button>
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" (click)="exportExcel()"><i class="fa fa-file-excel-o"></i> خروجی اکسل</button>
      </div>
    </div>
    <div class="body">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div>
        <span>در حال دریافت اطلاعات…</span>
      </div>

      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && filteredRows.length === 0">
        <div class="ico-big"><i class="fa fa-inbox"></i></div>
        <h4>{{ hasActiveFilters ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'اطلاعاتی برای نمایش وجود ندارد' }}</h4>
        <span class="muted">
          {{ hasActiveFilters ? 'فیلترها را تغییر دهید و دوباره جستجو کنید.' : 'هنوز داده‌ای برای این گزارش ثبت نشده است.' }}
        </span>
        <div class="empty-actions" *ngIf="hasActiveFilters">
          <button class="btn btn-primary" type="button" (click)="clearSearch()">
            <i class="fa fa-undo"></i> حذف فیلترها
          </button>
        </div>
      </div>

      <div class="state error" id="stError" [class.show]="hasError">
        <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
        <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="loadReport()">
          <i class="fa fa-refresh"></i> تلاش مجدد
        </button>
      </div>

      <div class="table-scroll" [id]="definition.columns ? null : printSectionId" *ngIf="!loading && !hasError && filteredRows.length">
        <ng-container *ngIf="definition.columns; else originalTable">
          <ng-container [ngTemplateOutlet]="configuredTable" [ngTemplateOutletContext]="{ rows: pagedRows, offset: (currentPage - 1) * pageSize, columns: definition.columns }"></ng-container>
        </ng-container>
        <ng-template #originalTable>
        <table [id]="tableId">
          <thead id="thead">
            <tr *ngIf="context.id === '1'"><th class="col-num">#</th><th>نام متحرک</th><th>شماره پرسنلی</th><th class="col-amt">مسافت (km)</th><th>محدوده تاریخ</th></tr>
            <tr *ngIf="context.id === '2'"><th class="col-num">#</th><th>شماره پرسنلی</th><th>نام متحرک</th><th class="col-amt">مسافت (km)</th><th>مدت کارکرد</th><th class="col-amt">L/h</th><th class="col-amt">سوخت مصرفی (litre)</th></tr>
            <tr *ngIf="context.id === '3'"><th class="col-num">#</th><th>نام متحرک</th><th>شماره پرسنلی</th><th>زمان کل</th><th>زمان حرکت</th><th>زمان توقف</th></tr>
          </thead>
          <tbody id="tbody">
            <ng-container *ngFor="let row of pagedRows; let index = index">
              <tr *ngIf="context.id === '1'"><td class="col-num">{{ (currentPage - 1) * pageSize + index + 1 | faNum }}</td><td>{{ row.strFullName | faNum }}</td><td>{{ row.strPersonnelID | faNum }}</td><td class="col-amt">{{ row.fDistance | faNum }}</td><td>{{ context.endDate | faNum }} - {{ context.startDate | faNum }}</td></tr>
              <tr *ngIf="context.id === '2'"><td class="col-num">{{ (currentPage - 1) * pageSize + index + 1 | faNum }}</td><td>{{ row.strPersonnelID | faNum }}</td><td>{{ row.strFullName | faNum }}</td><td class="col-amt">{{ row.fDistance | faNum }}</td><td>{{ row.strTotalDurationOperation | faNum }}</td><td class="col-amt">{{ row.fConsumption | faNum }}</td><td class="col-amt">{{ row.fGasPer100 | faNum }}</td></tr>
              <tr *ngIf="context.id === '3'"><td class="col-num">{{ (currentPage - 1) * pageSize + index + 1 | faNum }}</td><td>{{ row.strFullName | faNum }}</td><td>{{ row.strPersonnelID | faNum }}</td><td>{{ row.strFunction | faNum }}</td><td>{{ row.strAbsoulatFunction | faNum }}</td><td>{{ row.strParkTime | faNum }}</td></tr>
            </ng-container>
          </tbody>
          <tfoot>
            <tr *ngIf="context.id === '1'">
              <td colspan="3" class="label">تعداد کل : <span>{{ filteredRows.length | number | faNum }}</span></td>
              <td class="total col-amt">{{ totalDistance | number:'1.0-2' | faNum }} کیلومتر</td>
              <td></td>
            </tr>
            <tr *ngIf="context.id === '2'">
              <td colspan="6" class="label">تعداد کل : <span>{{ filteredRows.length | number | faNum }}</span></td>
              <td class="total col-amt">{{ totalFuel | number:'1.0-2' | faNum }} لیتر</td>
            </tr>
            <tr *ngIf="context.id === '3'">
              <td colspan="6" class="label">تعداد کل : <span>{{ filteredRows.length | number | faNum }}</span></td>
            </tr>
          </tfoot>
        </table>
        </ng-template>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length" [pageSizeOptions]="pageSizeOptions" (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
  </section>
  <div class="print-only" [id]="printSectionId" *ngIf="definition.columns && !loading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
    <h1 class="title">{{ definition.title }}</h1>
    <span class="muted">{{ subtitle | faNum }}</span>
    <p class="muted" *ngIf="context.id === '4'">{{ printedBy | faNum }} · تاریخ تهیه: {{ printDate | faNum }}</p>
    <ng-container [ngTemplateOutlet]="configuredTable" [ngTemplateOutletContext]="{ rows: filteredRows, offset: 0, columns: definition.printColumns || definition.columns }"></ng-container>
    </div>
  </div>

  <ng-template #configuredTable let-tableRows="rows" let-offset="offset" let-tableColumns="columns">
    <table>
      <thead>
        <tr>
          <th class="col-num">#</th>
          <th *ngFor="let column of tableColumns" [class.col-amt]="column.format === 'number'">{{ column.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tableRows; let index = index">
          <td class="col-num">{{ offset + index + 1 | faNum }}</td>
          <td *ngFor="let column of tableColumns" [class.col-amt]="column.format === 'number'">
            <ng-container *ngIf="column.format === 'number'; else textCell">{{ cellValue(row, column) | number:'1.0-2' | faNum }}</ng-container>
            <ng-template #textCell>{{ cellValue(row, column) | faNum }}</ng-template>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="label" [attr.colspan]="totalStartIndex(tableColumns) + 1">
            تعداد کل : <span>{{ filteredRows.length | number | faNum }}</span>
          </td>
          <td *ngFor="let column of tableColumns.slice(totalStartIndex(tableColumns))" class="total" [class.col-amt]="column.format === 'number'">
            <ng-container *ngIf="column.summary === 'duration'; else numericTotal">{{ totalTime | faNum }} {{ column.unit }}</ng-container>
            <ng-template #numericTotal><ng-container *ngIf="column.total">{{ totals[column.field] | number:'1.0-2' | faNum }} {{ column.unit }}</ng-container></ng-template>
          </td>
        </tr>
      </tfoot>
    </table>
  </ng-template>
</main>
